import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GridModule } from '@progress/kendo-angular-grid';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { HttpClientModule } from '@angular/common/http';
import { CgpModule } from '../../../../src/app/shared/cgp.module';
import { LayoutModule } from '@progress/kendo-angular-layout';
import { CardGridModule } from '../../../../src/app/shared/card-grid/card-grid.module';
import { VeComponent } from './ve.component';
import { AuthGuard } from '../../auth.guard';
import { IntlModule } from '@progress/kendo-angular-intl';
import { UploadModule } from '@progress/kendo-angular-upload';
import { AdministrationModule, administrationRoutes } from './administration/administration.module';
import { WorkOrdersModule, workOrdersRoutes } from './work-orders/work-orders.module';

/** COMPONENTS */
import { WorkOrderScheduleComponent } from './work-order-schedule/work-order-schedule.component';
import { EngineerScheduleComponent } from './engineer-schedule/engineer-schedule.component';

/** SERVICES */
import {
    AuthorizationService,
    DocumentService,
    EngineerScheduleService,
    GlobalRegionService,
    UserSettingsService,
    WorkOrderScheduleService,
} from './ve.service';

import { WorkOrderScheduleEditService } from './work-order-schedule/work-order-schedule-edit.service';
import { EngineerScheduleEditService } from './engineer-schedule/engineer-schedule-edit.service';
import { WorkOrderScheduleAddComponent } from './work-order-schedule/work-order-schedule-add/work-order-schedule-add.component';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyCardModule as MatCardModule } from '@angular/material/legacy-card';
import { MatLegacyDialogModule as MatDialogModule } from '@angular/material/legacy-dialog';
import { MatIconModule } from '@angular/material/icon';

/** ROUTES */
export const veRoutes = {
    path: 'VE',
    component: VeComponent,
    canActivate: [AuthGuard],
    data: {
        navbarId: 've',
        expectedRoles: ['Administrator', 'Manager', 'Lead', 'Engineer', 'User']
    },
    children:
        [
            administrationRoutes,
            workOrdersRoutes,
            {
                path: 'Work-Order-Schedule',
                component: WorkOrderScheduleComponent,
                canActivate: [AuthGuard],
                data: {
                    expectedRoles: ['Administrator', 'Lead']
                },
            },
            {
                path: 'Engineer-Schedule',
                component: EngineerScheduleComponent,
                canActivate: [AuthGuard],
                data: {
                    expectedRoles: ['Administrator', 'Lead', 'Engineer']
                },
            }
        ]
};

/** MODULES */
@NgModule({
    imports: [
        AdministrationModule,
        CardGridModule,
        CgpModule,
        CommonModule,
        DropDownsModule,
        FormsModule,
        GridModule,
        HttpClientModule,
        IntlModule,
        LayoutModule,
        MatButtonModule,
        MatCardModule,
        MatDialogModule,
        MatIconModule,
        ReactiveFormsModule,
        RouterModule,
        UploadModule,
        WorkOrdersModule,
        FormsModule.withConfig({
            callSetDisabledState: 'whenDisabledForLegacyCode',
        })
    ],
    declarations: [
        EngineerScheduleComponent,
        VeComponent,
        WorkOrderScheduleComponent,
        WorkOrderScheduleAddComponent,
    ],
    providers: [
        AuthorizationService,
        DocumentService,
        EngineerScheduleEditService,
        EngineerScheduleService,
        GlobalRegionService,
        UserSettingsService,
        WorkOrderScheduleEditService,
        WorkOrderScheduleService,
    ]
})

export class VEModule { }
